module.exports = __webpack_public_path__ + "img/zenfone4.3bceaa8a.jpg";